var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEditPencel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0204 1.97974C14.9521 2.91138 14.9521 4.42187 14.0204 5.35351L6.04156 13.3324C5.85698 13.517 5.62742 13.6502 5.37558 13.7189L1.96512 14.649C1.59187 14.7508 1.24938 14.4083 1.35118 14.0351L2.2813 10.6246C2.34999 10.3728 2.48321 10.1432 2.66779 9.95862L10.6467 1.97974C11.5783 1.0481 13.0888 1.0481 14.0204 1.97974ZM10.0003 4.04034L3.3749 10.6657C3.31337 10.7273 3.26896 10.8038 3.24607 10.8877L2.54617 13.454L5.11246 12.7541C5.19641 12.7312 5.27293 12.6868 5.33446 12.6253L11.9597 5.99967L10.0003 4.04034ZM11.3538 2.68684L10.707 3.33301L12.6663 5.29301L13.3133 4.6464C13.8545 4.10529 13.8545 3.22796 13.3133 2.68684C12.7722 2.14573 11.8949 2.14573 11.3538 2.68684Z",
    fill: "#222729"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditPencel);
export default __webpack_public_path__ + "static/media/icon-edit-pencel.ec58874e8665d5a80423f96fb6c55702.svg";
export { ForwardRef as ReactComponent };